import { memo } from 'react';
import { FlexBox } from '@dfl/mui-react-common';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import StarHalfRoundedIcon from '@mui/icons-material/StarHalfRounded';
import { ITestimony } from '../../interfaces';

const TestimonyRateCell = ({ record }: { record: ITestimony }) => {
  const rate = record.rate || 0;
  const fullStars = Math.floor(rate);
  const hasHalfStar = rate % 1 >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <FlexBox alignItems={'center'} gap={0.5}>
      {Array.from({ length: fullStars }).map((_, i) => (
        <StarRoundedIcon key={`full-${i}`} sx={{ color: 'primary.main', fontSize: 25 }} />
      ))}
      {hasHalfStar && (
        <StarHalfRoundedIcon sx={{ color: 'primary.main', fontSize: 25 }} />
      )}
      {Array.from({ length: emptyStars }).map((_, i) => (
        <StarBorderRoundedIcon key={`empty-${i}`} sx={{ color: 'primary.main', fontSize: 25 }} />
      ))}
    </FlexBox>
  );
};

export default memo(TestimonyRateCell);
